import { Routes, Route, useParams, Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "../../components/useAuth";
import { useForm } from "react-hook-form";
import "./Announcement.css";

const AnnouncementRow = (props) => {
  return (
    <div className="ann-row ann-row-body">
      <div className="ann-col ann-col-date">{props.release_datetime}</div>
      <div className="ann-col ann-col-category">{props.category}</div>
      <div className="ann-col ann-col-target">{props.to_str}</div>
      <div className="ann-col ann-col-body" title={props.body}>
        {props.body}
      </div>

      <div className="ann-col ann-col-actions">
        <Link
          to={"/announcement/" + props.id}
          data-id={props.id}
          className="btn btn-ghost btn-sm"
        >
          編集
        </Link>
        <Link
          to={"/announcement/delete/" + props.id}
          data-id={props.id}
          className="btn btn-danger btn-sm"
        >
          削除
        </Link>
      </div>
    </div>
  );
};

const api_url = "https://api.ope-note.jp/admin/announcement.php";

const AnnouncementHome = () => {
  const [itemList, setItemList] = useState([]);
  const [page, setCurrentPage] = useState(1);
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const getItemList = async () => {
      try {
        const response = await fetch(api_url, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ page: page, mode: "list", token: token }),
        });
        //console.log(response);
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error("404 error");
          }
          if (response.status === 401) {
            throw new Error("401 error");
          }
          throw new Error(response.status);
        }
        const data = await response.json();
        setItemList(data.data);
      } catch (err) {
        if (err.message === "404 error" || err.message === "401 error") {
          //console.log('navigate to /');
          navigate("/login");
        } else {
          console.log(err);
          setItemList([]);
        }
      }
    };
    getItemList();
  }, [page, token, navigate]);

  const tablelist = itemList.map((item) => (
    <AnnouncementRow
      key={item.id}
      release_datetime={item.release_datetime}
      id={item.id}
      category={item.category_name}
      to_user_id={item.to_user_id_label}
      body={item.body}
      to_str={item.to_str}
    />
  ));

  return (
    <>
      <div className="announcement-header">
        <h4 className="announcement-title">お知らせ一覧</h4>
        <Link to="0" className="btn btn-primary">
          ＋ 新規作成
        </Link>
      </div>

      <div className="announcement-card">
        <div className="ann-row ann-row-header">
          <div className="ann-col ann-col-date">公開日時</div>
          <div className="ann-col ann-col-category">カテゴリ</div>
          <div className="ann-col ann-col-target">対象</div>
          <div className="ann-col ann-col-body">内容</div>
          <div className="ann-col ann-col-actions">操作</div>
        </div>

        {tablelist.length > 0 ? (
          <div className="ann-table-body">{tablelist}</div>
        ) : (
          <div className="ann-empty">お知らせがまだ登録されていません。</div>
        )}
      </div>
    </>
  );
};

const RadioButtonComp = ({ options, name, def }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };
  return (
    <>
      {options.map((option) => (
        <div key={option.value}>
          <label>
            <input
              type="radio"
              value={option.value}
              checked={selectedOption === option.value || def === option.value}
              onChange={handleChange}
              name={name}
            />
            {option.label}
          </label>
        </div>
      ))}
    </>
  );
};

const ToUserCategoryIdAll = ({ register }) => {
  return (
    <>
      <input
        type="hidden"
        {...register("to_user_category_id", { required: true })}
        value="0"
      />
    </>
  );
};

//const ToUserId = ({ register, defaultOption, setValue }) => {
const ToUserId = ({ register, defaultOption, setValue, value }) => {
  const [searchUser, setSearchUser] = useState("");
  const [searchUserList, setSearchUserList] = useState([]);
  const { token } = useAuth();

  useEffect(() => {
    // 編集時などで defaultOption が渡されていれば、最初からリストに入れておく
    if (defaultOption) {
      setSearchUser("");
      setSearchUserList([
        {
          id: String(defaultOption.id),
          name: defaultOption.name,
          email: defaultOption.email,
        },
      ]);
      setValue("to_user_id", String(defaultOption.id));
    }
  }, [defaultOption, setValue]);
  const regToUserId = register("to_user_id", { required: true});
  const handleInputChange = (e) => {
    setSearchUser(e.target.value);
    search(e.target.value);
  };

  const search = async (value) => {
    if (value === "") {
      setSearchUserList([]);
      return;
    }

    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "search_user",
          token: token,
          val: value,
        }),
      });

      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setSearchUserList(data.data);
      }
    } catch (err) {
      setSearchUserList([]);
      console.log(err);
    }
  };

  return (
    <label style={{ display: "flex" }}>
      <span className="title">宛先個人を選択してください</span>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <input
          type="text"
          name="user_search"
          className="user_search_box"
          placeholder="氏名やEmailで検索"
          onChange={handleInputChange}
          value={searchUser}
        />
        <select
          name="to_user_id"
          size="5"
          {...regToUserId}
          value={value || ""}
        >
          {searchUserList.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name + "(" + item.email + ")"}
            </option>
          ))}
        </select>
      </div>
    </label>
  );
};

const ToUserCategoryIdOpe = ({ register, userCategoryList }) => {
  return (
    <div className="frm-row">
      <label>対象＝手術内容を選択した場合</label>
      <select
        name="to_user_category_id"
        className="frm-select"
        {...register("to_user_category_id", { required: true })}
      >
        <option value="">選択してください</option>
        {userCategoryList.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  );
};

const AnnouncementForm = () => {
  const { id } = useParams();
  const { token } = useAuth();
  const [categoryList, setCategoryList] = useState([]);
  const [userCategoryList, setUserCategoryList] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [error, setError] = useState("");
  const [fromTypeSelected, setFromTypeSelected] = useState("");
  const [toType, setToType] = useState("-1");
  const [defaultUserOption, setDefaultUserOption] = useState(null);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const toUserIdValue = watch("to_user_id");
  const fetchData = async () => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "category_list", token: token }),
      });
      if (!response.ok) {
        navigate("/");
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setCategoryList(data.data);
        setUserCategoryList(data.user_data);
        setStaffList(data.staff_data);
      }
      //console.log(data);
    } catch (err) {
      console.log(err);
      setCategoryList([]);
      setUserCategoryList([]);
      setStaffList([]);
    }
  };

  const editData = async (edit_id) => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "row", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setValue("release_datetime", data.data.release_datetime);
        setValue("category_id", data.data.category_id);
        setValue("to_user_id", data.data.to_user_id);
        setValue("from_type", data.data.from_type);
        setValue("body", data.data.body);
        setValue("link_url", data.data.link_url);
        setValue("to_user_category_id", data.data.to_user_category_id);
        setValue("staff_id", data.data.staff_id);
        setFromTypeSelected(data.data.from_type);
        setToType(String(data.data.to_type ?? "-1"));
        console.log(data.data);
        if (String(data.data.to_type) === "3" && data.data.to_user_id > 0) {
          // ここは API のキー名に合わせてください
          // 例: to_user_name / to_user_id_label / to_str など
          const userName =
            data.data.to_user_name ||
            data.data.to_user_id_label ||
            data.data.to_str ||
            `ID:${data.data.to_user_id}`;

          setDefaultUserOption({
            id: data.data.to_user_id,
            name: userName,
            email: data.data.to_user_email,
          });
        }
      } else {
        navigate("/announcement");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const init = async () => {
      await fetchData();
      if (id > 0) {
        await editData(id);
      } else {
        setValue("sortno", 100);
      }
    };
    init();
  }, [id, token, setValue]);

  const handleToTypeChange = (e) => {
    const value = e.target.value;
    setToType(value);

    switch (value) {
      case "1": // 手術内容　to_user_id = 0, to_user_category_id = to_user_category_id
        setValue("to_user_id", "0");
        break;
      case "2": // 全員 to_user_id = -1, to_user_category_id = 0
        setValue("to_user_id", "-1");
        setValue("to_user_category_id", "0");
        break;
      case "3": // 個人 to_user_id = to_user_id, to_user_category_id = 0
        setValue("to_user_category_id", "0");
        break;
      default:
      // とりあえず何もしない
    }
  };

  const onSubmit = async (data) => {
    let to_user_id = "-1";
    let to_user_category_id = "0";

    if (toType === "1") {
      // 手術内容
      to_user_category_id = data.to_user_category_id;
      to_user_id = "0";
    } else if (toType === "3") {
      // 個人あて
      to_user_id = data.to_user_id;
    }

    const post_data = {
      id: data.id,
      release_datetime: data.release_datetime,
      category_id: data.category_id,
      to_user_id: to_user_id,
      link_url: data.link_url,
      to_user_category_id: to_user_category_id,
      body: data.body,
      staff_id: data.staff_id,
      token: token,
      mode: "add",
    };

    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(post_data),
      });

      const resData = await response.json();
      if (response.ok) {
        if (resData.result) {
          navigate("/announcement");
        } else {
          setError(resData.error);
        }
      } else {
        setError("失敗しました");
      }
    } catch (err) {
      console.log(err);
      setError("通信エラーです");
    }
  };

  const formTypeOpt = [
    {
      label: "医療機関",
      value: "1",
    },
    {
      label: "運営",
      value: "2",
    },
  ];

  const toTypeOpt = [
    {
      label: "個人",
      value: "3",
    },
    {
      label: "手術内容",
      value: "1",
    },
    {
      label: "全員",
      value: "2",
    },
  ];

  const handleFromTypeChange = (event) => {
    setFromTypeSelected(event.target.value);
  };

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../announcement" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>
        <h4 className="announcement-title">
          {id > 0 ? "お知らせ編集" : "お知らせ新規作成"}
        </h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}

        <div className="frm-row">
          <label>公開日時</label>
          <input
            type="datetime-local"
            className="frm-input"
            {...register("release_datetime", {
              required: true,
            })}
          />
          {errors.release_datetime && (
            <div className="frm-error-text">公開日時を設定してください</div>
          )}
        </div>

        <div className="frm-row">
          <label>カテゴリ</label>
          <select
            name="category_id"
            className="frm-select"
            {...register("category_id", { required: true })}
          >
            <option value="">選択してください</option>
            {categoryList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {errors.category_id && (
            <div className="frm-error-text">カテゴリを選択してください</div>
          )}
        </div>

        <div className="frm-row">
          <label>スタッフ</label>
          <select
            name="staff_id"
            className="frm-select"
            {...register("staff_id")}
          >
            <option value="">選択してください</option>
            {staffList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div className="frm-row">
          <label>外部リンク（詳細表示用）</label>
          <input
            type="text"
            className="frm-input"
            placeholder="https://..."
            {...register("link_url")}
          />
        </div>

        <div className="frm-row">
          <label>対象</label>
          <div className="ann-radio-group">
            {toTypeOpt.map((option) => (
              <label key={option.value} className="ann-radio">
                <input
                  type="radio"
                  value={option.value}
                  checked={toType === option.value}
                  onChange={handleToTypeChange}
                  name="to_type"
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>

        <div className="frm-row">
          {toType === "2" && <></>}
          {toType === "3" && (
            <ToUserId
              register={register}
              defaultOption={defaultUserOption}
              setValue={setValue}
              value={toUserIdValue}
            />
          )}
          {errors.to_user_id && (
            <div className="frm-error-text">宛先個人を指定してください</div>
          )}
          {toType === "1" && (
            <ToUserCategoryIdOpe
              register={register}
              userCategoryList={userCategoryList}
            />
          )}
          {errors.to_user_category_id && (
            <div className="frm-error-text">宛先手術内容を選択してください</div>
          )}
        </div>

        <div className="frm-row">
          <label>内容</label>
          <textarea
            className="frm-textarea"
            rows={5}
            {...register("body", {
              required: true,
            })}
          />
          {errors.body && (
            <div className="frm-error-text">内容を入力してください</div>
          )}
        </div>

        <input type="hidden" name="id" {...register("id")} defaultValue={id} />

        <div className="frm-footer">
          <button type="submit" className="btn btn-primary">
            更新する
          </button>
        </div>
      </form>
    </div>
  );
};

const AnnouncementDeleteConfirm = () => {
  const { id } = useParams();
  const { token } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [viewData, setViewData] = useState([]);

  const { register, handleSubmit } = useForm();

  const targetData = async (edit_id) => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "detail", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setViewData(data.data);
      } else {
        navigate("/announcement");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (id > 0) {
      targetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    const post_data = {
      id: data.id,
      token: token,
      mode: "delete",
    };

    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(post_data),
      });

      const resData = await response.json();
      if (response.ok) {
        if (resData.result) {
          navigate("/announcement");
        } else {
          setError(resData.error);
        }
      } else {
        setError("失敗しました");
      }
    } catch (err) {
      console.log(err);
      setError("通信エラーです");
    }
  };

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../announcement" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>
        <h4 className="announcement-title">お知らせ削除確認</h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}
        <div className="frm-row">
          <div className="delete-warning">
            このデータを削除しますか？（元に戻せません）
          </div>
        </div>

        <div className="frm-row">
          <label>公開日時</label>
          <div className="frm-static">{viewData.release_datetime}</div>
        </div>
        <div className="frm-row">
          <label>カテゴリ</label>
          <div className="frm-static">{viewData.category_name}</div>
        </div>
        <div className="frm-row">
          <label>スタッフ</label>
          <div className="frm-static">{viewData.staff_name}</div>
        </div>
        <div className="frm-row">
          <label>リンク</label>
          <div className="frm-static">{viewData.link_url}</div>
        </div>
        <div className="frm-row">
          <label>対象</label>
          <div className="frm-static">{viewData.to_user_id_label}</div>
        </div>

        <div className="frm-row">
          <label>内容</label>
          <div
            className="frm-static"
            dangerouslySetInnerHTML={{ __html: viewData.body }}
          />
        </div>

        <input type="hidden" name="id" {...register("id")} defaultValue={id} />

        <div className="frm-footer frm-footer-between">
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => navigate("/announcement")}
          >
            キャンセル
          </button>
          <button type="submit" className="btn btn-danger">
            削除する
          </button>
        </div>
      </form>
    </div>
  );
};

const Announcement = () => {
  return (
    <div className="announcement-page">
      <h3 className="sub_title">お知らせ管理</h3>
      <div className="announcement-inner">
        <Routes>
          <Route path="/" element={<AnnouncementHome />} />
          <Route path=":id" element={<AnnouncementForm />} />
          <Route path="/delete/:id" element={<AnnouncementDeleteConfirm />} />
        </Routes>
      </div>
    </div>
  );
};

export default Announcement;
